/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import { ActionHandler, ActionHandlerType } from '../action-handler';
import { ResetterService } from '../../resetter/resetter.service';
import { SyncService } from '../../sync/sync.service';

@Injectable({
  providedIn: 'root',
})
export class HardResetActionHandler implements ActionHandler {
  // Public Member
  public readonly name: ActionHandlerType = 'hardreset';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private resetter: ResetterService,
    private syncService: SyncService,
  ) {}

  // ActionHandler
  public async executeAction(params?: any): Promise<any> {
    await this.resetter.hardreset();
  }

  // Private Functions
}
